
interface LensInventoryErrorProps {
  error: string | null;
}

export function LensInventoryError({ error }: LensInventoryErrorProps) {
  return (
    <div className="text-center p-4 border border-destructive/20 bg-destructive/10 rounded-lg text-destructive">
      {error}
    </div>
  );
}
